// extracted by mini-css-extract-plugin
export var imageWrapper = "ArticleCategoryHeader-module--imageWrapper--G0Aoh";
export var text = "ArticleCategoryHeader-module--text--HVeBl";
export var title = "ArticleCategoryHeader-module--title--DTy2Y";
export var wrapper = "ArticleCategoryHeader-module--wrapper--ZwEFO";